// extracted by css-extract-rspack-plugin
export default {"DeactivationModal":"DeactivationModal-NQjs0g","deactivationModal":"DeactivationModal-NQjs0g"};